// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Kv58r","requiredAsterisk":"Info_requiredAsterisk__3b2Zx"};